<template>
  <div :id="idxDrag" class="drop-area">
    <form class="my-form">
      <p>Arraste uma Imagem para cá</p>
      <input type="file" :id="fileDrag" class="fileElem" multiple accept="image/*" @change="handleFilesIput($event)">
      <label class="button" :for="fileDrag">Selecione uma Imagem</label>
    </form>
  </div>
</template>

<script>
export default {
  data () {
    return {
      dropArea: null,
      idxDrag: 'dragable_' + new Date().getTime() + '_' + parseInt((Math.random() * 100000)),
      fileDrag: 'file_' + new Date().getTime() + '_' + parseInt((Math.random() * 100000))
    }
  },

  mounted () {
    this.dropArea = document.getElementById(this.idxDrag)
    // this.dropArea.addEventListener('dragenter', this.handlerFunction, false)
    // this.dropArea.addEventListener('dragleave', this.handlerFunction, false)
    // this.dropArea.addEventListener('dragover', this.handlerFunction, false)
    this.dropArea.addEventListener('drop', this.handleDrop, false)
    ;['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
      this.dropArea.addEventListener(eventName, this.preventDefaults, false)
    })
    ;['dragenter', 'dragover'].forEach(eventName => {
      this.dropArea.addEventListener(eventName, this.highlight, false)
    })
    ;['dragleave', 'drop'].forEach(eventName => {
      this.dropArea.addEventListener(eventName, this.unhighlight, false)
    })
  },

  methods: {
    handlerFunction (e) {
      console.log(e)
    },

    handleDrop (e) {
      let dt = e.dataTransfer
      let files = dt.files

      this.handleFiles(files)
    },

    handleFilesIput (e) {
      let files = e.target.files
      this.handleFiles(files)
    },

    handleFiles (files) {
      this.$emit('uploadImage', files[0])
    },

    preventDefaults (e) {
      e.preventDefault()
      e.stopPropagation()
    },

    highlight() {
      this.dropArea.classList.add('highlight')
    },

    unhighlight() {
      this.dropArea.classList.remove('highlight')
    }
  }
}
</script>

<style lang="scss" scoped>
.drop-area {
  border: 2px dashed #ffffff;
  border-radius: 4px;
  font-family: sans-serif;
  padding:30px 20px;;
  width:250px;
  height:200px;
  color:#ffffff;
  text-align:center;
}
.drop-area.highlight {
  border-color: purple;
}
p {
  margin-top: 0;
}
.my-form {
  margin: 50px auto;
}
.button {
  display: inline-block;
  padding: 10px;
  background: #ccc;
  cursor: pointer;
  border-radius: 5px;
  border: 1px solid #ccc;
}
.button:hover {
  background: #ddd;
}
.fileElem {
  display: none;
}

</style>
